var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Stats")]),_c('b-tabs',[_c('b-tab',{attrs:{"title":"General"}},[_vm._v("\n\t\t\tUtilisateurs: "+_vm._s(_vm.users.length)),_c('br'),_vm._v("\n\t\t\tProjets: "+_vm._s(_vm.list_projects.length)),_c('br'),_vm._v("\n\t\t\tNombre de lignes dans la base de données: "+_vm._s(_vm.nb_lines)+"\n\t\t")]),_c('b-tab',{attrs:{"title":"Utilisateurs"}},[_c('p',[_vm._v("\n\t\t\t\tNombre d'utilisateurs théorique : "+_vm._s(_vm.users.length)),_c('br'),_vm._v("\n\t\t\t\tUtilisateurs avec date de dernière connexion : "+_vm._s(_vm.last_date_login)),_c('br'),_vm._v("\n\t\t\t\tUtilisateurs s'étant connectés il y a moins d'un mois : "+_vm._s(_vm.last_date_login_month)),_c('br'),_vm._v("\n\t\t\t\tUtilisateurs en attente de redéfinir leurs mots de passe : "+_vm._s(_vm.is_token_new_password)+"\n\t\t\t")]),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.users,"sort-by":"last_date_login","sort-desc":true,"fields":[
				{
					key: 'identifiant',
					label: 'Identifiant',
					sortable: true,
				},
				{
					key: 'prenom',
					label: 'Prénom',
					sortable: true,
				},
				{
					key: 'nom',
					label: 'Nom',
					sortable: true,
				},
				{
					key: 'email',
					label: 'email',
					sortable: true,
				},{
					key: 'groups',
					label: 'Groupes',
					sortable: true,
				},{
					key: 'is_token_new_password',
					label: 'Demande nouveau mp',
					sortable: true,
				},{
					key: 'last_date_login',
					label: 'Dernière connexion',
					sortable: true,
				}]},scopedSlots:_vm._u([{key:"cell(is_token_new_password)",fn:function(data){return [_vm._v("\n\t\t\t\t\t"+_vm._s(data.item.is_token_new_password ? "oui" : "")+"\n\t\t\t\t")]}}])}),_c('h3',[_vm._v("Téléchargement")]),_c('p',[_vm._v("Filtrer par groupe")]),_c('b-input',{model:{value:(_vm.filter_group),callback:function ($$v) {_vm.filter_group=$$v},expression:"filter_group"}}),_c('br'),_c('b-button',{on:{"click":function($event){return _vm.dowload(false, false)}}},[_vm._v("Tous les utilisateurs")]),_c('br'),_c('br'),_c('b-button',{on:{"click":function($event){return _vm.dowload(true, false)}}},[_vm._v("Sans dernière connexion")]),_c('br'),_c('br'),_c('b-button',{on:{"click":function($event){return _vm.dowload(false, true)}}},[_vm._v("Avec redéfinition de mot de passe")]),_c('br'),_c('br'),_c('b-button',{on:{"click":function($event){return _vm.dowload(true, true)}}},[_vm._v("Sans dernière connexion et avec redéfinition de mot de passe")])],1),_vm._l((_vm.dashboards),function(dashboard,idx){return _c('b-tab',{key:idx,attrs:{"title":dashboard}},[_c('Dashboard',{attrs:{"minimal":true,"_name":dashboard}})],1)}),_c('b-tab',{attrs:{"title":"Projets"}},[_c('ProjectsStats')],1),_c('b-tab',{attrs:{"title":"Traitements"}},[_c('TreatmentsStats')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }